export default __webpack_public_path__ + "static/media/Lotus Talisman.d7256ae6.jpg";